import { render } from "./MemberShop.vue?vue&type=template&id=7225e874"
import script from "./MemberShop.vue?vue&type=script&lang=js"
export * from "./MemberShop.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__